import React, { useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";

let timer = null;

const InfiniteScroll = ({
  children,
  hasMore,
  loadMore,
  scrollTarget,
  isLoading = false,
  dataLength = 0,
}) => {
  const handleLoadNextPage = useCallback(() => {
    if (hasMore && !isLoading && dataLength > 0) {
      loadMore();
    }
  }, [hasMore, loadMore, isLoading, dataLength]);

  useEffect(() => {
    let scrollable;
    if (scrollTarget && scrollTarget.length > 0) {
      scrollable = document.getElementById(scrollTarget);
      scrollable.addEventListener("scroll", () => {
        if (scrollable.scrollHeight - 30 < window.innerHeight + scrollable.scrollTop) {
          if (timer !== null) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            handleLoadNextPage();
          }, 100);
        }
      });
    }
    return () => {
      if (scrollable) scrollable.removeEventListener("scroll", () => {});
    };
  }, [handleLoadNextPage, scrollTarget]);

  return (
    <Box width="100%">
      {children}
      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        alignItems="center"
        pt={5}
        style={{ direction: "rtl" }}
      >
        {hasMore ? (
          <Typography variant="h2" textAlign="center">
            برای نمایش داده‌های بیشتر صفحه را پیمایش کنید.
          </Typography>
        ) : (
          <Typography variant="h2" textAlign="center">
            داده‌ی بیشتری برای نمایش وجود ندارد.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

InfiniteScroll.propTypes = {
  children: PropTypes.node,
  hasMore: PropTypes.bool,
  loadMore: PropTypes.func,
  scrollTarget: PropTypes.string,
  isLoading: PropTypes.bool,
  dataLength: PropTypes.number,
};

export default React.memo(InfiniteScroll);
